import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import FlexibleDurationFilter from '../store/FlexibleDurationFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';

export default class FlexibleStayConnector implements Observer {
    readonly #typeInput: HTMLInputElement;

    readonly #monthsInput: HTMLInputElement;

    readonly #filter: FlexibleDurationFilter;

    constructor(
        typeInput: HTMLInputElement,
        monthsInput: HTMLInputElement,
        filter: FlexibleDurationFilter
    ) {
        this.#typeInput = typeInput;
        this.#monthsInput = monthsInput;
        this.#filter = filter;

        this.#typeInput.addEventListener('change', this.#updateFilter.bind(this));
        this.#monthsInput.addEventListener('change', this.#updateFilter.bind(this));
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof FlexibleDurationFilter)) {
            return;
        }

        // don't update the element when the filter is disabled (used to 'remember' flexible search)
        if (!subject.enabled) return;

        this.#typeInput.value = subject.parameters.flexibleDurationType || '';
        this.#monthsInput.value = subject.parameters.flexibleBookingMonths || '';
    }

    public static connectToElements(
        typeInputQuerySelector: string,
        monthsInputQuerySelector: string
    ): void {
        const filters = HouseSearchFilters.getInstance();
        const typeInput = document.querySelector(typeInputQuerySelector) as HTMLInputElement | null;
        const monthsInput = document.querySelector(
            monthsInputQuerySelector
        ) as HTMLInputElement | null;
        const filter = filters.get(FlexibleDurationFilter.NAME) as
            | FlexibleDurationFilter
            | undefined;

        if (!typeInput || !monthsInput || !filter) return;

        const connector = new FlexibleStayConnector(typeInput, monthsInput, filter);
        filter.attach(connector);
    }

    #updateFilter(): void {
        const months = this.#monthsInput.value.length ? this.#monthsInput.value.split(',') : [];
        this.#filter.setFlexibleStay(
            this.#typeInput.value,
            months?.map((month) => Number(month))
        );
    }
}
